import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { endpoints } from "../../constants/endpoints";
import { toast } from "react-toastify";
import api from "../../services/instance";
import { useNavigate } from "react-router-dom";

export const loginAPI = createAsyncThunk(
    'loginAPI',
    async (data, { rejectWithValue }) => {
        try {
            const response = await api.post(endpoints.login(), data);
            return response.data;
        } catch (error) {
            console.error("Login error here:", error);
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);

const initialState = {
    user: JSON.parse(localStorage.getItem("user")) || {},
    loading: false,
    emailThatReject: null,
    subscriptionState: false
};

export const AuthSlice = createSlice({
    initialState,
    name: "AuthSlice",
    reducers: {
        handleLogout: (state, acion) => {
            // const navigate = useNavigate()
            localStorage.removeItem("token");
            localStorage.removeItem("user");
            state.user = {}
            // navigate('/signin')          
        },

        updateUser: (state, action) => {
            state.user = action.payload
        }
    },
    extraReducers: (builder) => {
        builder.addCase(loginAPI.pending, (state, action) => {
            state.loading = true;
        });

        builder.addCase(loginAPI.fulfilled, (state, action) => {
            state.loading = false;
            const userData = action.payload?.data;
            if (userData) {
                state.user = userData;
                console.log(userData.token, "userData from authSlice");
                localStorage.setItem("token", userData?.token);
                localStorage.setItem("user", JSON.stringify(userData));
            } else {
                console.error("Invalid user data in API response:", action.payload);
            }
        });

        builder.addCase(loginAPI.rejected, (state, action) => {
            state.loading = false;
            state.emailThatReject = action.payload.data
            // toast.error(action.payload?.message || 'Login failed. Enter correct credentials.');
        });

    }
})

export const { handleLogout, updateUser } = AuthSlice.actions
export default AuthSlice.reducer